/* eslint-disable */ 
const state = {
	name: 'user name',
	username: 'username',
	email: 'email',
	contact_number: '012-3456789'
};

// getters
const getters = {
	username:(state)=>{
		let userData = JSON.parse(localStorage.getItem('user_data'))
		let name = capitalizeWords(`${userData.first_name} ${userData.last_name}`)
		return name
	},
	name:(state)=>{
		let userData = JSON.parse(localStorage.getItem('user_data'))
		let name = capitalizeWords(`${userData.first_name} ${userData.last_name}`)
		return name
	},
	email: (state)=>{
		let userData = JSON.parse(localStorage.getItem('user_data'))
		return userData.email
	},
	contact_number: (state)=>{
		return userData.contact_number
	}
};

const actions = {}
const mutations = {}

function capitalizeWords(str) {
  return str
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};
